import { useMutation } from '@apollo/react-hooks';
import moment from 'moment';
import React, { useState } from 'react';
import styled from 'styled-components';
import Button from '../../Button';
import * as Price from '../../../util/Price';
import { SEND_WELCOME_TEXT } from '../../../graphql/queries';
import colors from '../../../styles/colors';
import * as Time from '../../../util/Time';
import TagsList from '../TagsList';

const ListWrapper = styled.ul`
  width: calc(75vw - 20px);
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  margin: 0 10px;
  list-style: none;
  padding: 0 15px;
  overflow: auto;
  max-height: 60vh;
  position: relative;
`;

const ListItem = styled.li`
  min-height: 30px;
  border-bottom: 1px solid ${colors.grey5};
  padding: 10px;
  margin-bottom: 5x;
  font-size: 13px;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  color: ${(props) => (props.onClick ? colors.seaGreen : null)};
`;

const ListKey = styled.div`
  display: flex;
  flex: 1;
  font-weight: 450;
`;
const TagsHeader = styled.div`
  display: flex;
  flex: 1;
  font-weight: 450;
  margin-bottom: 10px;
`;

const ListValue = styled.div`
  display: flex;

  padding-left: 10px;
  justify-content: flex-start;
`;

const ButtonContainer = styled.div`
  padding: 20px 0px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-radius: 7px;
  min-height: 40px;
  position: sticky;
  bottom: 0;
  background-color: ${colors.white};
`;

const ContactDetailsModal = ({
  contactData: contact,
  getRefferedContactsClick,
  fetching,
  close,
}) => {
  const [welcomed, setWelcomed] = useState(false);
  const [sendWelcome, { loading }] = useMutation(SEND_WELCOME_TEXT, {
    variables: {
      phoneNumbers: [contact.phoneNumber],
    },
    onError(error) {
      console.log(error);
    },
    onCompleted() {
      setWelcomed(true);
    },
  });

  const hasBeenWelcomed = contact.welcomed > Time.now() - Time.DAY * 7 || welcomed;

  const refAcceptedClickable = (contact.totalCouponsAcceptedRef > 0 && !fetching) || false;

  const redeemClickable = (contact.totalCouponsRedRef > 0 && !fetching) || false;

  return (
    <ListWrapper>
      {contact && (
        <>
          {/* <ListHeader>{contact.phoneNumber}</ListHeader> */}
          <ListItem>
            <ListKey>Phone Number:</ListKey>{' '}
            <ListValue> {contact.phoneNumber}</ListValue>
          </ListItem>
          <ListItem>
            <ListKey>Created At :</ListKey>{' '}
            <ListValue>
              {moment(contact.createdAt * 1000).format('L')}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>Last Imported :</ListKey>
            <ListValue>
              {' '}
              {moment(contact.lastImported * 1000).format('L')}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>Current Available Balance :</ListKey>
            <ListValue>
              {`$${Price.output(contact.currentAvailableBalance, true)}`}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>Total Credits Granted :</ListKey>
            <ListValue>
              {`$${Price.output(contact.totalCreditGranted, true)}`}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>Total Credits Redeemed :</ListKey>
            <ListValue>
              {`$${Price.output(contact.totalCreditRedeemed, true)}`}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>Total Discount Granted :</ListKey>
            <ListValue>{contact.totalCouponsGranted}</ListValue>
          </ListItem>
          <ListItem>
            <ListKey>Total Discount Redeemed :</ListKey>
            <ListValue>{contact.totalCouponsRedeemed}</ListValue>
          </ListItem>
          <ListItem
            onClick={
              refAcceptedClickable
                ? () => {
                  getRefferedContactsClick({
                    phoneNumber: contact.phoneNumber,
                    couponType: 'accepted',
                    _id: contact._id,
                  });
                  close();
                }
                : null
            }
          >
            <ListKey>Total Discount Accepted :</ListKey>
            <ListValue>
              {`$${Price.output(contact.totalCouponsAcceptedRef, true)}`}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>
              Total Ref Clicks<div>:</div>
            </ListKey>
            <ListValue>{contact.totalRefClicks}</ListValue>
          </ListItem>
          <ListItem
            onClick={
              redeemClickable
                ? () => {
                  getRefferedContactsClick({
                    phoneNumber: contact.phoneNumber,
                    couponType: 'redeemed',
                    _id: contact._id,
                  });
                  close();
                }
                : null
            }
          >
            <ListKey>Total Ref Discount Redeemed :</ListKey>
            <ListValue>
              {`$${Price.output(contact.totalCouponsRedRef, true)}`}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>Total Ref Conversion Rate :</ListKey>
            <ListValue>{contact.totalConversionRateRef}%</ListValue>
          </ListItem>
          <ListItem>
            <ListKey>Original Source :</ListKey>
            <ListValue>{contact.originalSource}</ListValue>
          </ListItem>
          <ListItem>
            <ListKey>Opt-In Method :</ListKey>
            <ListValue>{contact.optInMethod}</ListValue>
          </ListItem>
          <ListItem>
            <ListKey>Last Opt-In :</ListKey>
            <ListValue>
              {contact.lastOptIn
                ? moment(contact.lastOptIn * 1000).format('L')
                : ''}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>Opt-Out :</ListKey>
            <ListValue>
              {contact.optOut ? moment(contact.optOut * 1000).format('L') : ''}
            </ListValue>
          </ListItem>
          <ListItem>
            <ListKey>SMS Opt-Out :</ListKey>
            <ListValue>
              {contact.smsCampaignOptOut
                ? moment(contact.smsCampaignOptOut * 1000).format('L')
                : ''}
            </ListValue>
          </ListItem>
          <ListItem>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
              }}
            >
              <TagsHeader>Tags :</TagsHeader>
              <TagsList
                phoneNumber={contact.phoneNumber}
                attachedTags={contact.attachedTags}
              />
            </div>
          </ListItem>

          {!hasBeenWelcomed && (
            <ButtonContainer>
              <Button
                text="Send Welcome"
                onClick={() => sendWelcome()}
                width="70%"
                type="button"
                padding="0px"
                height="35px"
                loading={loading}
              />
            </ButtonContainer>
          )}
        </>
      )}
    </ListWrapper>
  );
};

export default ContactDetailsModal;
